import { UserRole } from 'dy-frontend-http-repository/lib/data/enums';
import { useStore } from 'effector-react';
import React from 'react';

import TeamTag from '@app/containers/components/TeamTag';
import { $task } from '@app/containers/pages/Task/store/states';
import { $authorizedUser } from '@app/containers/store/states';
import { Button, Card, IconName } from '@blueprintjs/core';
import Flex from '@components/Flex';
import Heading from '@components/Heading';
import DevText from '@components/Text';
import { openModal } from '@modals/store/events';
import AssignPrimaryTeamModal, { AssignPrimaryTeamModalProps } from '@pages/Task/modals/AssignPrimaryTeamModal';

const adminAccessRoles = [UserRole.CORE_ROOT, UserRole.CORE_ADMIN, UserRole.CORE_PLATFORM_DEV];
const allowTaskShadowIdAssigningRoles = [
    ...adminAccessRoles,
    UserRole.CORE_OPERATIONS_MANAGER,
    UserRole.CORE_ART_DIRECTOR,
    UserRole.CORE_ACCOUNT_DIRECTOR,
    UserRole.CORE_PROJECT_MANAGER,
];

const Teams: React.FC = () => {
    const me = useStore($authorizedUser);
    const task = useStore($task);

    if (!task) {
        return null;
    }

    const renderPrimaryTeam = () => {
        if (!task.primary_team) {
            return <DevText muted>No primary team is assigned</DevText>;
        }

        return <TeamTag id={task.primary_team.id} color={task.primary_team.color} name={task.primary_team.title} />;
    };

    const renderAssignPrimaryTeamAction = () => {
        // Permission check
        if (!allowTaskShadowIdAssigningRoles.includes(me?.user.role)) {
            return null;
        }

        let buttonIcon: IconName | undefined = undefined;
        let buttonText = 'Assign';
        if (task.primary_team !== null) {
            buttonText = 'Reassign';
            buttonIcon = 'pivot';
        }

        return (
            <Button
                icon={buttonIcon}
                onClick={() => {
                    openModal<AssignPrimaryTeamModalProps>({
                        ModalComponent: AssignPrimaryTeamModal,
                        data: { taskId: task.id, teamId: task.primary_team?.id },
                    });
                }}
            >
                {buttonText}
            </Button>
        );
    };

    return (
        <>
            <Card className="mb-2">
                <Flex className="mb-2" direction="row" justify="space-between" align="center">
                    <Heading type="h4">Primary Team</Heading>
                    {renderAssignPrimaryTeamAction()}
                </Flex>

                {renderPrimaryTeam()}
            </Card>
        </>
    );
};

export default Teams;
